 import { phonelogin, logout } from '@/api/user'
 import { getToken, setToken, removeToken, setrefresh_Token, removerefresh_Token, 
  setExpires, getuserInfo, setuserInfo } from '@/utils/auth'

const state = {
    token: getToken(),
    userInfo: getuserInfo(),
    isLogin: false,
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USERINFO: (state, data) => {
    state.userInfo = data
  },
}

const actions = {

  // user login
  login({ commit }, userInfo) {
    const { phone, phoneCode } = userInfo
    return new Promise((resolve, reject) => {
        phonelogin({ phone: phone.trim(), phoneCode: phoneCode}).then(response => {
          let curTime = parseInt(new Date().getTime() / 3600000 )  // 小时
          const { data } = response
          commit('SET_TOKEN', data.access_token)
          commit('SET_USERINFO', data.user_tel)
          setuserInfo(data.user_tel)
          setToken(data.access_token)
          setrefresh_Token(data.refresh_token)
          setExpires(curTime)
          resolve()
        }).catch(() => {
            reject()
        })
    }) 
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(res => {
        commit('SET_TOKEN','')
        removeToken()
        removerefresh_Token()
        resolve()
        }).catch(error => {
          reject()
      })
    }) 
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN','')
      removeToken()
      resolve()
    })
  },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js